function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3324"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3044",
  d: "M60.019 5.913c.735-.84 62.839-5.074 77.476-4.906 15.676.179 83.219 1.187 87.358 3.987 1.8 1.214 25.9 48.091 25.9 48.091s4.148 2.521 8.392 9.742 11.966 1.277 13.2 21.078 13.032 3.409 11.37 58.279l-2.096 38.531s4.913 7.369-51.311 8.518c-46.04.942-76.649 1.206-86.225 1.271-4.769.032-33.3.8-89.525-.352S3.25 181.634 3.25 181.634l-2.094-38.532c-1.663-54.87 10.138-38.478 11.37-58.279s8.953-13.858 13.2-21.078 8.393-9.741 8.393-9.741S58.138 8.06 60.019 5.913z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3045",
  d: "M38.908 53.171L62.521 7.935l82.021-2.971 79.176 3.2 23.867 45.221z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3046",
  d: "M12.713 83.251l38.162.393s-10.385 1.285-9.13 47.476c0 .126-27.877-1.219-27.943-3.579-.208-7.455-.013-22.414-.013-22.414s-1.651-1.126-2.03-7.179c-.205-3.27.327-7.051.954-14.697z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3313"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3047",
  d: "M271.965 82.785l-38.162.393s10.384 1.285 9.129 47.476c0 .126 27.877-1.219 27.943-3.579.208-7.455.013-22.414.013-22.414s1.651-1.126 2.03-7.179c.205-3.266-.327-7.047-.953-14.697z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3048",
  d: "M16.633 70.716c-3.641-.029-15.209-.812-15-8.953.257-10-.01-8.586.657-10.055 1.391-3.062 3.334-7.381 6.012-7.629 2.929-.271 12.76-.378 14.33.7.66.454.623 10.69 1.057 11.318.46.665 7.327.383 7.327.383",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3314"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3049",
  d: "M269.311 70.817c3.641-.029 15.21-.812 15-8.953-.257-10 .01-8.586-.657-10.055-1.391-3.062-3.334-7.381-6.012-7.629-2.929-.271-12.76-.378-14.33.7-.659.454-.623 10.69-1.057 11.318-.46.665-7.326.382-7.326.382",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3050",
  d: "M15.225 156.263c.694-.679 25.532.188 26.317 1 .676.7 1 18.252-.288 19.014s-17.513-.125-18.542-.533c-1.244-.493-7.367-5.994-7.684-7.488-.28-1.33-.52-11.293.197-11.993z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3315"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3051",
  d: "M270.697 155.905c-.694-.679-25.532.188-26.318 1-.676.7-1 18.252.288 19.014s17.513-.125 18.542-.533c1.244-.493 7.367-5.994 7.684-7.488.281-1.326.52-11.291-.196-11.993z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3052",
  d: "M17.246 187.691c3.329 3.745 5.793 6.681 5.793 8.138s4.3 13.523 12.9 14.356 112.115 3.808 112.115 3.808 105.24-3.769 110.31-7.906c5.6-4.573 2.769-9.808 4.3-12.365l5.967-7.108",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3053",
  d: "M3.372 183.434c-.694 8.26 1.6 52.2 7.775 53.381s20.412 1.891 24.434 1.319c4.317-.616 6.317-.832 7.913-2.846s5.627-15.1 5.418-24.4",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3316"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3054",
  d: "M281.596 182.228c.694 8.261-1.6 52.2-7.774 53.381s-20.412 1.892-24.434 1.319c-4.317-.616-6.317-.833-7.914-2.847s-5.627-15.1-5.419-24.4",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3055",
  d: "M34.193 210.413c.622 5.945.972 13.989 3.07 18.691",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3317"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3056",
  d: "M251.155 208.359c-.622 5.945-.972 13.988-3.07 18.691",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3318"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3057",
  d: "M50.525 83.661c6.8-.151 10.889-.246 13.478-.356",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3319"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3058",
  d: "M222.168 83.659l12.6-.5",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3059",
  d: "M54.065 147.429c.319-9.232-.146-47.711 1.329-49.847 5.523-7.994 10.813-18.621 13.712-18.691 5.006-.121 146.913-2.53 149.547.75 1.47 1.832 12.085 15.7 12.147 17.8.051 1.789 3.2 50.08.929 50.254-7.345.57-177.725 1.503-177.664-.266z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3060",
  d: "M232.005 147.477l43.19-1.532",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3061",
  d: "M53.881 146.937l-45.175-1.892",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3320"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3062",
  d: "M172.678 53.255a26.286 26.286 0 0141.13 0z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3321"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3063",
  d: "M70.187 93.086l145.366-.63",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3322"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3064",
  d: "M70.187 135.282l145.366-.63",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3323"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3065",
  d: "M70.187 114.183l145.366-.63",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

function SvgFrontDistantGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285.314,
    height: 239.352,
    viewBox: "0 0 285 239"
  }, props), _ref);
}

export default SvgFrontDistantGraphic;